type LogLevel = 'debug' | 'info' | 'warn' | 'error';

export class Logger {
    private debug_enabled: boolean;
    private prefix: string = '[Honch]';

    constructor(debug: boolean) {
        this.debug_enabled = debug;
    }

    setDebug(enabled: boolean): void {
        this.debug_enabled = enabled;
    }

    debug(message: string, data?: Record<string, unknown>): void {
        if (!this.debug_enabled) return;
        this.log('debug', message, data);
    }

    info(message: string, data?: Record<string, unknown>): void {
        if (!this.debug_enabled) return;
        this.log('info', message, data);
    }

    warn(message: string, data?: Record<string, unknown>): void {
        this.log('warn', message, data);
    }

    error(message: string, data?: Record<string, unknown>): void {
        this.log('error', message, data);
    }

    private log(level: LogLevel, message: string, data?: Record<string, unknown>): void {
        const fullMessage = `${this.prefix} ${message}`;

        switch (level) {
            case 'debug':
                console.debug(fullMessage, data || '');
                break;
            case 'info':
                console.info(fullMessage, data || '');
                break;
            case 'warn':
                console.warn(fullMessage, data || '');
                break;
            case 'error':
                console.error(fullMessage, data || '');
                break;
        }
    }
}
